<template>
    <form class="form-helpdesk max-w-2xl">
        <div class="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2" v-if="helpdesk">
            <form-field-textarea
                class="sm:col-span-2"
                id="message"
                label="How can we help?"
                field="message"
                :value="helpdesk.message"
                :placeholder="placeholder"
                @update="updateHelpdeskField"
            ></form-field-textarea>
            <form-field-text
                v-if="!isLoggedIn"
                id="first-name"
                label="First name *"
                field="first_name"
                autocomplete="given-name"
                :value="helpdesk.first_name"
                @update="updateHelpdeskField"
            ></form-field-text>
            <form-field-text
                v-if="!isLoggedIn"
                id="last-name"
                label="Last name *"
                field="last_name"
                autocomplete="family-name"
                :value="helpdesk.last_name"
                @update="updateHelpdeskField"
            ></form-field-text>
            <form-field-text
                v-if="!isLoggedIn"
                class="sm:col-span-2"
                id="email"
                label="Email *"
                field="email"
                type="email"
                autocomplete="email"
                :value="helpdesk.email"
                @update="updateHelpdeskField"
            ></form-field-text>
            <form-field-checkbox
                v-if="!isLoggedIn"
                class="sm:col-span-2"
                id="checkbox"
                :title="$config.public.settingsNotificationsMailersTitle"
                :label="$config.public.settingsNotificationsMailersText"
                :info="$config.public.settingsNotificationsMailersInfo"
                field="checkbox"
                @update="clickMailingListCheckbox"
            ></form-field-checkbox>
            <form-field-re-captcha
                class="mt-6"
                field="recaptcha_response"
                :onUpdate="updateHelpdeskField"
                :error="error"
                :success="success"
            ></form-field-re-captcha>
        </div>
        <div class="mt-10">
            <button-block
                buttonText="Contact Helpdesk"
                :buttonDisabled="
                    disabled || !helpdesk.message || !helpdesk.first_name || !helpdesk.last_name || !helpdesk.email
                "
                :buttonClick="postHelpdesk"
            ></button-block>
            <alert-success class="mt-5" :alert="success"></alert-success>
            <alert-error class="mt-5" :alert="error"></alert-error>
        </div>
    </form>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'FormHelpdesk',
    props: {
        placeholder: {
            required: false,
            type: String,
            default: null,
        },
    },
    computed: {
        ...mapState(useStoreAuth, {
            isLoggedIn: 'isLoggedIn',
        }),
        ...mapState(useStoreHelpdesk, {
            helpdesk: 'helpdesk',
            disabled: 'disabled',
            success: 'success',
            error: 'error',
        }),
    },
    methods: {
        ...mapActions(useStoreHelpdesk, {
            initHelpdesk: 'initHelpdesk',
            updateHelpdeskField: 'updateHelpdeskField',
            postHelpdesk: 'postHelpdesk',
        }),
        clickMailingListCheckbox(response) {
            let value = response.value;
            if (this.updateHelpdeskField && value !== undefined) {
                this.updateHelpdeskField({field: 'notifications_mailers', value});
                this.updateHelpdeskField({field: 'notifications_mailers_consent_method', value: 'toggle'});
                this.updateHelpdeskField({
                    field: 'notifications_mailers_title',
                    value: this.$config.public.settingsNotificationsMailersTitle,
                });
                this.updateHelpdeskField({
                    field: 'notifications_mailers_text',
                    value: this.$config.public.settingsNotificationsMailersText,
                });
                this.updateHelpdeskField({
                    field: 'notifications_mailers_info',
                    value: this.$config.public.settingsNotificationsMailersInfo,
                });
            }
        },
    },
    created: function () {
        if (!this.helpdesk) this.initHelpdesk();
    },
};
</script>
